import { Typography } from '@/components/UI/Typography'
import type { FC } from 'react'

type Props = {
  /** ポイント履歴のラベル（例: スタンプ獲得（渡月橋）） */
  label: string
  /** ポイント数（正: 獲得, 負: 使用） */
  point: number
  /** 取得日（例: 2026-03-10） */
  acquiredAt: string
}

/** ポイント履歴の1行コンポーネント */
export const PointHistoryItem: FC<Props> = ({ label, point, acquiredAt }) => {
  const isPositive = point >= 0

  return (
    <div>
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex-1 min-w-0 mr-3">
          <Typography variant="caption1" component="p" className="truncate underline">
            {label}
          </Typography>
          <Typography variant="caption2" component="p">
            {acquiredAt}
          </Typography>
        </div>
        <p
          className="font-bold text-[20px] leading-[32px] whitespace-nowrap"
          style={{ color: isPositive ? '#000000' : '#d46a6a' }}
        >
          {point}pt
        </p>
      </div>
      <div className="h-px bg-gray-200 w-[270px] mx-auto" />
    </div>
  )
}
